import { useState, useMemo } from 'react';
import axios from 'axios';

/**
 * Custom React hook to manage state
 */

const useAppState = () => {
  const initialState = { 
    user: {},
    authForm: {}
  }

  // Managing the state using React.useState()
  const [state, setState] = useState(initialState)

  // Building our actions. We'll use useMemo() as an optimization,
  // so this will only ever be called once.
  const actions = useMemo(() => getActions(setState), [setState])

  return { state, actions }
}


// Individual actions that call setState().
const getActions = setState => ({
  login: (e, formData) => {
    return new Promise((resolve, reject) => {
      e.preventDefault()
      let url = 'https://blooming-spire-64013.herokuapp.com/users/authenticate';
      setState(state => {
        axios.post(url, formData, { withCredentials: true})
        .then(response => {
          resolve({...state, user: response.data})
        }) 
        .catch(err => console.error("Hubo un error en la petición: ", err));
      })
    })
  },
  signup: (e, formData) => {
    return new Promise((resolve, reject) => {
    e.preventDefault()
    
    let url = 'https://blooming-spire-64013.herokuapp.com/users/register';
    
    setState(state => {
      axios.post(url, formData, { withCredentials: true})
      .then(response => { 
        resolve({message: "Usuario creado con éxito"})
        // return {...state, user: response.data}
      }) 
      .catch(err => {
        reject({message: "Ya existe un usuario registrado con este correo."})
        console.log("Hubo un error en la petición: ", err)
      })
    });
  })
  },
  logout: () => {
    setState(state => ({...state, }))
  }
})

export default useAppState;